import React, { useEffect, useRef } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import googleCalendarPlugin from "@fullcalendar/google-calendar";

function MonthCalendar({
  month,
  selectedCalendars,
  googleCalendarApiKey,
  selectedEvent,
  setSelectedEvent,
  calendarContainerRef,
  setCalendarView,
  setSelectedDate,
}) {
  const popupRef = useRef(null);
  const handleEventClick = (info) => {
  info.jsEvent.preventDefault();
  const eventRect = info.el.getBoundingClientRect();
  const calendarRect = calendarContainerRef.current.getBoundingClientRect();
  setSelectedEvent({
    event: info.event,
    x: eventRect.left - calendarRect.left,
    y: eventRect.bottom -calendarRect.top -200,
  });
};
  useEffect(() => {
  if (!selectedEvent || !popupRef.current) {
    return;
  }
  const popup = popupRef.current;
  const calendar = popup.closest(".month-calendar");
  let left = selectedEvent.x;
  let top = selectedEvent.y;
  const popupWidth = popup.offsetWidth;
  const padding = 10;
  const calendarWidth = calendar.offsetWidth;
  // Don't go off the right side
  if (left + popupWidth > calendarWidth - padding) {
    left = calendarWidth - popupWidth - padding;
  }
  // Don't go off the left side
  if (left < padding) {
    left = padding;
  }
  popup.style.left = `${left}px`;
  popup.style.top = `${top}px`;

}, [selectedEvent]);

  return (
    <div className="month-calendar">
      <FullCalendar
        key={`${selectedCalendars}-${month.getTime()}`}
        plugins={[
          dayGridPlugin,
          interactionPlugin,
          googleCalendarPlugin,
        ]}
        dayCellContent={(arg) => {
        return arg.date.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          });
        }}
        initialView="dayGridMonth"
        initialDate={month}
        headerToolbar={{
          left: "",
          center: "title",
          right: "",
        }}
        height="auto"
        dayMaxEvents={3}
        nextDayThreshold="03:00:00"
        googleCalendarApiKey={googleCalendarApiKey}
        eventSources={selectedCalendars.map((calendarId) => ({
                googleCalendarId: calendarId,
                }))}
        eventClick={handleEventClick}
        dateClick={(info) => {
          setSelectedDate(info.date);
          setCalendarView("day");
        }}
        datesSet={() => setSelectedEvent(null)}
      />
      <div className="calendarInstruction">click a date, see a date</div>
    </div>
  );
}

export default React.memo(MonthCalendar);